import {
  AutoAwesome,
  Chair,
  Collections,
  CoPresent,
  EmojiEvents,
  EmojiFoodBeverage,
  EmojiPeople,
  Groups,
  HowToReg,
  LocalCafe,
  Lightbulb,
  Person,
  Restaurant,
} from "@mui/icons-material";

export const programmeEvents = [
  {
    time: "8:30 am",
    titles: ["Registration Opens"],
    locations: ["Atrium (Level 3, RVRC Block G)"],
    icon: <HowToReg />,
  },
  {
    time: "9:00 am",
    titles: ["Symposium Introduction by RVRC Symposium 2026 Co-Chairs"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <CoPresent />,
  },
  {
    time: "9:10 am",
    titles: ["Welcome Address by RVRC College Master"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <Person />,
  },
  {
    time: "9:20 am",
    titles: ["Keynote Address by Mr. Sean Lam"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <Lightbulb />,
  },
  {
    time: "9:40 am",
    titles: ["Thematic Thread Highlights"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <AutoAwesome />,
  },
  {
    time: "10:00 am",
    titles: ["Poster Presentations and Interactive Booths / Networking Tea Session"],
    locations: ["Atrium (Level 3, RVRC Block G)"],
    icon: <EmojiFoodBeverage />,
  },
  {
    time: "11:10 am",
    titles: ["Thread 1: Edu-venture", "Thread 2: Adventure"],
    locations: [
      "MPR 1 & 2 (Level 3, RVRC Block G)",
      "Master's Lounge (Level 3, RVRC Block G)",
    ],
    icon: <Groups />,
  },
  {
    time: "1:10 pm",
    titles: ["Presentation of Symposium Recognition Awards by RVRC Rector"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <EmojiEvents />,
  },
  {
    time: "1:20 pm",
    titles: ["Closing Remarks by RVRC Symposium 2026 Co-Chairs"],
    locations: ["MPR 1 & 2 (Level 3, RVRC Block G)"],
    icon: <EmojiPeople />,
  },
  {
    time: "1:30 pm",
    titles: ["Networking Lunch"],
    locations: ["Atrium (Level 3, RVRC Block G)"],
    icon: <Restaurant />,
  },
];

export const thread1MPR1Events = [
  {
    time: "11:10 am",
    course: "RVN2000",
    titles: ["Leveraging a Receptive Community with RVRC Clothing Swap"],
    abstract: "Fashion Parade is a Gen Z community aiming to inspire fellow youths to engage in sustainable fashion through events, social media engagement, arts, and other methods. We propose that a collaboration with RVRC represents an excellent opportunity for both Fashion Parade as well as the college. A clothes swap event hosted in RVRC with the help of Fashion Parade would both help students declutter, find new pieces of clothing, as well as promote sustainable fashion to a wider audience.",
    locations: ["Lee Xi Zhe, Ansel Lim Wei Xuan"],
    icon: <CoPresent />,
  },
  {
    time: "11:30 am",
    course: "RVN2002",
    titles: ["A Guide to Ecotourism"],
    abstract: "Our project presents a guide to ecotourism, examining how individual traveller behaviour can shape conservation outcomes. Drawing on experiential learning from the RVN2002 module, we engaged in ecotourism activities such as hiking in Taman Negara National Park, exploring Guasik Naga Cave, and birdwatching at Fraser’s Hill. These firsthand experiences revealed how poorly managed or irresponsible ecotourism can harm fragile ecosystems despite its conservation-oriented intent. In response, our project outlines accessible guidelines for responsible ecotourism, emphasising low-impact practices, respect for wildlife, and adherence to park regulations. Our guide highlights the role of eco-tourists in supporting sustainable conservation and protecting natural environments for future generations.",
    locations: ["Ng Hao Wei, Ling Zi Xi, Pan Zi Hao"],
    icon: <CoPresent />,
  },
  {
    time: "11:50 am",
    course: "RVN2003",
    titles: ["Innovation in Action"],
    abstract: "With Singapore’s focus on building a more inclusive society for persons with disabilities, RVN2003 Understanding Disability and Fostering Inclusivity emphasises learning through real-world engagement. This presentation showcases our project: Innovation in Action, a collaboration with MINDS to design, test, and refine inclusive programmes for persons with moderate intellectual disabilities. Working with clients ranging from young adults to elderly individuals, each with diverse abilities, communication styles, and mobility needs, we supported vocational tasks such as packing headphones for Singapore Airlines. Through hands-on observation, facilitation, and iteration, we streamlined work processes while reflecting on ethical considerations, challenges, and meaningful learning moments.",
    locations: ["Leroy Tan Ming Xiang, Rakshana Ravichandran, Zhuang Ying'En Shanice"],
    icon: <CoPresent />,
  },
  {
    time: "12:10 pm",
    course: "RVC2000",
    titles: ["Sustainability Initiatives in Education (East Malaysia)"],
    abstract: "Quality Education is one of the seventeen sustainable development goals identified by the United Nations and plays a critical role in promoting a more sustainable future. As youths represent the next generation of sustainability leaders, our group sought to explore how educational institutions in East Malaysia are integrating sustainability into their curricula and public outreach efforts. From engagement sessions conducted by the WWF to practical training for aspiring marine biologists at the Borneo Marine Research Institute, this project examines how institutions equip their students with sustainability education through practical, real-world experiences.",
    locations: ["Elby Joseph Roy, Lim Ying Heng, Ng Chin Tiong Ryan, Hang Kai Jing Mike"],
    icon: <CoPresent />,
  },
  
  {
    time: "12:30 pm",
    titles: ["Break"],
    locations: ["MPR 1"],
    icon: <LocalCafe />,
  },
  {
    time: "12:40 am",
    course: "RVC1000",
    titles: ["Building Jeong Without Words (Interactive Session)"],
    abstract: "Workplace cultures vary across different countries around the world. While some cultures may appear similar, subtle differences often influence professional interactions. One such example is the comparison between Singaporean and Korean workplace cultures. As South Korea is a major economic and business partner in Asia, there are increasing opportunities to collaborate with Korean professionals. Understanding Korean workplace culture and recognising how it differs from Singapore’s is both relevant and important to ensure successful collaboration. Jeong culture, a uniquely Korean concept emphasising emotional bonds, loyalty, and long-term relationships, plays a significant role in workplace dynamics. Our group aims to explore how Jeong culture shapes professional relationships in Korea.",
    locations: ["Chen Kaiwen, Mah Hao Jun, Tay Chik Kong, Shawn"],
    icon: <CoPresent />,
  },
];

export const thread1MPR2Events = [
  {
    time: "11:10 am",
    course: "RVX1002",
    titles: ["An Examination of the Confucian Concept 耻 (chǐ)"],
    abstract: "This study examines the Confucian moral value chǐ, often translated as “shame,” and argues that such renderings risk angiocentric distortion. Drawing on classical Confucian texts across dynasties and a survey of 18 native Chinese speakers, the study analyses the enduring components of chǐ. Using the Natural Semantic Metalanguage (NSM), it explicates chǐ as a moral value centred on reflection and behavioural correction, mediated by guilt, responsibility, and reputation. The findings show that chǐ functions as an active, transformative ethical mechanism rather than a passive emotion.",
    locations: ["Clarence Chow"],
    icon: <CoPresent />,
  },
  {
    time: "11:30 am",
    course: "RVX1003",
    titles: ["Film Critique of Oppenheimer"],
    abstract: "This presentation revisits my CA2 pitch and CA3 final critique for RVX1003, focusing on Christopher Nolan’s Oppenheimer (2023) through the lens of the director’s signature style. I analyse how non-linear storytelling, subjective cinematography, and immersive sound design shape the film’s “Great Man” narrative and convey Oppenheimer’s inner conflict. By closely examining scenes such as the Trinity Test, victory speech, and security hearing, the project explores how cinematic form influences meaning. Reflecting on the module, watching the film in class and learning specific filming techniques changed how I approach cinema, allowing me to interpret films more thoughtfully and appreciate the deliberate craft behind what I watch.",
    locations: ["Cheng Qingyuan"],
    icon: <CoPresent />,
  },
  {
    time: "11:50 am",
    course: "RVSS1001",
    titles: ["Liveable Spaces and Connecting Communities at NUS"],
    abstract: "This project addresses the task of reimagining a liveable space within the National University of Singapore through principles of sustainable city design. Informed heavily by insights gained from course field trips, our group re-envisions Lover’s Park as a vibrant and inclusive campus hub. Paying homage to the Central Library Building (CLB) as NUS’s former civic and intellectual centre, the proposal seeks to reinject social and spatial vitality into the site. The redesigned space integrates spaces for faculty, students, and visitors, drawing from our observations during field trips. This fosters interaction, accessibility, and long-term social sustainability.",
    locations: [
      "Mohammad Nuruldin Bin Sahad, Lim Yi Jie, Nguyen Anh Duc, Ong Kai Siang Lionel, Ravichandran Vaishnavi",
    ],
    icon: <CoPresent />,
  },
  {
    time: "12:10 pm",
    course: "RVSS1003",
    titles: ["The Amazing Berlayer-Labrador Nature Walk"],
    abstract: "We created a guided learning walk through Berlayer Creek and Labrador Nature Reserve to help participants see Singapore’s green spaces in new ways. Rather than focusing on biodiversity alone, the walk examined how natural ecosystems, historical landmarks, and human activities intersect within this coastal landscape. Through a series of planned stops, participants were introduced to mangrove habitats, local wildlife, wartime heritage, and the impacts of urban development. Together, these elements highlighted the value of ecosystem services and encouraged reflection on shared responsibility in caring for Singapore’s natural spaces.",
    locations: [
      "Tan Yi Jun Keith, Jordan Teo Qi Dian, Joey Liew Zi Yi, Marcus Lee Wei, Se Bo Heng",
    ],
    icon: <CoPresent />,
  },
  {
    time: "12:30 pm",
    titles: ["Break"],
    locations: ["MPR 2"],
    icon: <LocalCafe />,
  },
  {
    time: "12:40 pm",
    course: "RVSS1004",
    titles: ["Echoes of Kristang Heritage: Bringing Branyo (Interactive Session)"],
    abstract: "Regardless of Race profoundly reshaped our understanding of race in Singapore. The course challenged assumptions shaped by dominant narratives of multiculturalism and meritocracy, pushing us to confront the gap between policy ideals and lived realities. Through a cultural immersion project on the Kristang community, we learned how smaller ethnic groups face cultural erosion not through overt discrimination, but structural neglect under the CMIO framework. This experience highlighted that racial harmony does not guarantee cultural equity. Overall, RVSS1004 deepened our awareness of race as a structural issue and strengthened our commitment to empathy, inclusion, and informed dialogue in a diverse society.",
    locations: ["Chee Wei En, Nguyen Tram Anh, Ikeda Fuyu"],
    icon: <CoPresent />,
  },
];

export const thread2Events = [
  {
    time: "11:10 am",
    titles: ["Panel Discussion 1 (Sustainability)"],
    locations: ["RV Forestore, Intertidal Walk & Clean, Ngee Ann Polytechnic Environmental Rangers Club"],
    icon: <Chair />,
  },
  {
    time: "11:50 am",
    titles: ["Break"],
    locations: ["Master's Lounge"],
    icon: <LocalCafe />,
  },
  {
    time: "12:00 pm",
    titles: ["Panel Discussion 2 (Workplace Readiness)"],
    locations: ["Industry Engagement, RV Sustainability Consulting, NUS Entrepreneurship Society"],
    icon: <Chair />,
  },
];

export const posterGalleryEvents = [
  {
    time: "10:00 am",
    titles: [
      "Poster Gallery / Interactive Booths by Community Partners / Networking Tea Session",
    ],
    locations: ["Atrium (Level 3, RVRC Block G)"],
    icon: <Collections />,
  },
];
